/** @format */

import Master from '../Layouts/Master';

const Dashboard = () => {
	return (
		<Master>
			<div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
				<div className='d-flex flex-row mt-2'>
					<i className='fad fa-list f-20 text-secondary mx-2'></i>
					<h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
						پنل مدیریت
					</h1>
				</div>
			</div>
		</Master>
	);
};

export default Dashboard;
